import { Textarea } from '@/components/common/Textarea'
import { StepShell } from '../StepShell'

const SUGGESTIONS = [
  'Symptomatic irreversible pulpitis wrt 36',
  'Chronic generalized gingivitis',
  'Dentoalveolar abscess',
]

export function ProvisionalDiagnosisStep({ value, onChange, errors = {} }) {
  const v = { diagnosis_text: '', ...(value || {}) }
  const set = (patch) => onChange?.({ ...v, ...patch })

  return (
    <StepShell
      eyebrow="Section 10 — Phase 4"
      title="Provisional diagnosis"
      description="Working diagnosis based on history and examination."
    >
      <Textarea
        label="Diagnosis"
        required
        rows={3}
        value={v.diagnosis_text}
        onChange={(e) => set({ diagnosis_text: e.target.value })}
        placeholder="e.g. Symptomatic irreversible pulpitis wrt 36"
        error={errors.diagnosis_text}
      />
      <div>
        <p className="label-text mb-2">Common diagnoses</p>
        <div className="flex flex-wrap gap-1.5">
          {SUGGESTIONS.map((s) => (
            <button
              key={s}
              type="button"
              onClick={() => set({ diagnosis_text: s })}
              className="rounded-full bg-white px-3 py-1.5 text-xs font-semibold text-ink-700 ring-1 ring-inset ring-ink-200 transition hover:bg-primary-50 hover:text-primary-800 hover:ring-primary-200"
            >
              {s}
            </button>
          ))}
        </div>
      </div>
    </StepShell>
  )
}
